import { CanaryUsers } from '../../organisms';
import { Header } from '../../molecules/Header';
import React from 'react';
import useStyles from './Page.styles';

export const Page: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.mainContainer}>
        <CanaryUsers />
      </div>
    </div>
  );
};
